import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Children, useEffect, useRef, useState } from 'react';
import { Subject } from 'rxjs';
import { findFirst } from "../../../../../../../../../../utils/arrays";

/** Класс, позволяющий удобнее подписываться на события */
var SubscribableIntersectionObserver = /*#__PURE__*/function (_IntersectionObserver) {
  function SubscribableIntersectionObserver(options) {
    var _this;
    _classCallCheck(this, SubscribableIntersectionObserver);
    _this = _callSuper(this, SubscribableIntersectionObserver, [function (entries) {
      _this.subject.next(entries);
    }, options]);
    _defineProperty(_this, "subject", new Subject());
    return _this;
  }
  _inherits(SubscribableIntersectionObserver, _IntersectionObserver);
  return _createClass(SubscribableIntersectionObserver, [{
    key: "subscribe",
    value: function subscribe(cb) {
      return this.subject.subscribe.bind(this.subject)(cb);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(IntersectionObserver));
/** Хок, для эффекта затумыванивания */
function withGradientScroll(observer) {
  return function (WrappedComponent) {
    return function (props) {
      var targetRef = useRef(null);
      var _useState = useState(Number(props.id)),
        _useState2 = _slicedToArray(_useState, 2),
        distance = _useState2[0],
        setDistance = _useState2[1];
      var opacity = Math.max(0.05, Math.exp(-distance || 0));
      useEffect(function () {
        var sub = observer.subscribe(function (entries) {
          var _entry$target;
          var entry = entries.find(function (_entry) {
            return _entry.isIntersecting;
          });
          var id = (entry === null || entry === void 0 ? void 0 : entry.target) && ((_entry$target = entry.target) === null || _entry$target === void 0 || (_entry$target = _entry$target.attributes) === null || _entry$target === void 0 || (_entry$target = _entry$target.getNamedItem('data-id')) === null || _entry$target === void 0 ? void 0 : _entry$target.value);
          if (id) {
            var _props$id;
            setDistance(Math.abs(Number(id) - Number((_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : 0)));
          }
        });
        return function () {
          sub.unsubscribe();
        };
      }, []);
      useEffect(function () {
        var current = targetRef.current;
        if (current) observer.observe(current);
        return function () {
          if (current) observer.unobserve(current);
        };
      }, [targetRef]);
      return /*#__PURE__*/React.createElement("div", {
        "data-id": props.id,
        onFocus: function onFocus(e) {
          if (e.target) {
            e.target.scrollIntoView({
              block: 'center',
              inline: 'center'
            });
          }
        },
        onKeyUp: function onKeyUp(e) {
          if (e.key !== 'Enter') return;
          props.onSelect();
        },
        ref: targetRef,
        style: {
          opacity: opacity
        }
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        ,
        tabIndex: 0,
        "data-t-id": "ModalWithSelection-ScrollWrapper"
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    };
  };
}

/** Обертка, позволяющая сделать скролл как на дизайнах карники с эффектом затуманивания */
export var ScrollWrapper = function ScrollWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _onSelect = _ref.onSelect;
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    _observer = _useState4[0],
    setObserver = _useState4[1];
  useEffect(function () {
    // NOTE: Window does not exist during server rendering
    if (typeof window !== 'undefined') {
      var observer = new SubscribableIntersectionObserver({
        root: document,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
      });
      setObserver(observer);
    }
  }, []);
  if (!_observer) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, Children.map(children, function (C, i) {
    var Component = findFirst([/*#__PURE__*/React.isValidElement(C) && withGradientScroll(_observer)(function () {
      return C;
    }), function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "C");
    }]);
    if (!Component) return null;
    return /*#__PURE__*/React.createElement(Component, {
      id: "".concat(i),
      key: i,
      onSelect: function onSelect() {
        return _onSelect(i);
      }
    });
  }));
};